import inject from './inject';
import connect from './connect';
import Provider from './provider';
import DataSource from './data-source';
import Store from './store';
import compose from './compose';
import hotRender from './hot-render';
import {throttle} from './utils';

export default {
    DataSource,
    inject,
    connect,
    Store,
    Provider,
    compose,
    throttle,
    hotRender
};



// WEBPACK FOOTER //
// ./src/index.js